import http from "../http-common";

class PasswordResetService {
  forgotPassword(email) {
    return http.post('/forgot-password', { email });
  }

  resetPassword(token, email, password, passwordConfirmation) {
    return http.post('/reset-password', {
      token,
      email,
      password,
      password_confirmation: passwordConfirmation,
    });
  }

  verifyResetToken(token) {
    return http.post('/verify-reset-token', { token });
  }
}

export default new PasswordResetService();
